<script>
  import { format } from "date-fns";
  import { it, enUS } from "date-fns/locale";

  import { currentTime } from "../utils/stores.js";

  export let locale;
  $: currentLocale = locale === "it" ? it : enUS;
</script>

<div class="container">
  <h2 class="today">
    <span>
      {format($currentTime, "d LLL yyyy - HH:mm:ss", { locale: currentLocale })}
    </span>
  </h2>
</div>

<style>
  .container {
    margin: 24px 0;
  }

  .today {
    width: 100%;
    text-align: center;
    border-bottom: 1px solid #000;
    line-height: 0.1em;
    margin: 10px 0 20px;
    font-size: 14px;
    text-transform: uppercase;
    color: #999;
  }

  .today span {
    background: #fff;
    padding: 0 10px;
  }
</style>
